// import "bootstrap/dist/css/bootstrap.min.css";
import MMALogo from "../utils/img/MMA-logo.png";
import { useTranslation } from "react-i18next";
import "../sass/layout/navbar/navbar.css";
import { GoTriangleDown, GoTriangleUp } from "react-icons/go";

import { ListGroup, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import UserService from "../services/api/UserService";
import { useSelector, useDispatch } from "react-redux";
import AccordionProfile from "./accordion/accordion";
import QuickAccessItem from "./quickaccess/quickaccessitem";
import RetireePortalButton from "./RetireePortalButton";
import { useState, useEffect } from "react";
import { getNewsletter, getButtonsInHome } from "../services/actions/home.action";

function QuickAccessMobileNav({ handleMenuToggle, isQAMenuOpen }) {
  const [newsletterExpanded, setNewsletterExpanded] = useState(false);

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { location, myUserInfo, quickAccessLinks, newsletter, buttons } = useSelector((state) => ({
    quickAccessLinks: state.homeReducer.quickaccess,
    location: state.homeReducer.location?.data,
    myUserInfo: state.homeReducer.myUserInfo,
    newsletter: state.homeReducer.newsletter,
    buttons: state.homeReducer.buttons,
  }));

  const id = location?.uniqueNonGuessableId;

  const loginStatus = UserService.isLoggedIn();

  const isRetireesPage = window.location.pathname.includes("/retirees");
  const isBasePath = () =>
    !!(window.location.pathname === "/" || !id || id === "/" || !location);

  useEffect(() => {
    if (isRetireesPage) {
      getNewsletter(dispatch, 'retireePortals');
    }
  }, [dispatch, isRetireesPage]);

  const getBlueCrossButton = () => {
    return buttons?.find(button =>
      button.name === "Blue Cross Blue Shield Benefits"
    );
  };

  // No links survived the location's product filtering: hide the whole nav, header included
  if (!loginStatus && !isBasePath() && !(quickAccessLinks?.length > 0)) {
    return null;
  }

  return (
    <Navbar expand="lg" className="quick-access-mobile">
      <Navbar.Brand
        style={{
          backgroundColor: "#ffffff",
          marginLeft: "1rem",
          fontSize: "1.1rem",
          fontWeight: "bold",
        }}
        href="#home"
      >
        Quick Access
      </Navbar.Brand>
      <Navbar.Toggle
        aria-controls="responsive-navbar-nav-qa-mobile"
        onClick={handleMenuToggle}
        className="toggler-custom-mobile"
        children={
          !isQAMenuOpen ? (
            <GoTriangleDown
              style={{
                fontSize: "0.7rem",
              }}
            />
          ) : (
            <GoTriangleUp
              style={{
                fontSize: "0.7rem",
              }}
            />
          )
        }
      />
      <Navbar.Collapse id="responsive-navbar-nav-qa-mobile">
        <Nav
        className="quick-access-mobile-nav"
        >
          {loginStatus ? (
            <div>
              <AccordionProfile />
              <RetireePortalButton />
            </div>
          ) : (
            <>


              {false ? (
                <AccordionProfile />
              ) : (
                <>
                  {isBasePath() ? (
                    <div
                    style={{
                      width: "85%",
                      alignSelf: "center",
                    }}
                    >
                      {isRetireesPage ? (
                        <>
                          {/* Contacts Section */}
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/retirees/contactMIIAteam'
                            style={{ fontWeight: '700' }}
                          >
                            {t("homepage.contacts")}
                          </Nav.Link>

                          {/* Quick Links Section */}
                          <div style={{ fontWeight: '700', padding: '0.9rem', fontSize: '17px', marginTop: '0.5rem' }}>
                            {t("homepage.quickLinks")}
                          </div>
                          {getBlueCrossButton()?.link && (
                            <Nav.Link
                              className="quick-access-mobile-link"
                              href={getBlueCrossButton().link}
                              target="_blank"
                              rel="noreferrer"
                              style={{ paddingLeft: '1.5rem' }}
                            >
                              {t("homepage.eap")}
                            </Nav.Link>
                          )}
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href="https://www.bluecrossma.org/myblue"
                            target="_blank"
                            rel="noreferrer"
                            style={{ paddingLeft: '1.5rem' }}
                          >
                            {t("homepage.findYourHealthPortal")}
                          </Nav.Link>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href="https://www.bluecrossma.org/myblue"
                            target="_blank"
                            rel="noreferrer"
                            style={{ paddingLeft: '1.5rem' }}
                          >
                            {t("homepage.myBlueInstantAccess")}
                          </Nav.Link>

                          {/* Newsletter Section - Expandable */}
                          {newsletter?.link && (
                            <>
                              <div
                                className="quick-access-mobile-link"
                                onClick={() => setNewsletterExpanded(!newsletterExpanded)}
                                style={{
                                  cursor: 'pointer',
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center'
                                }}
                              >
                                The MIIA Health Benefits Trust Retiree Review Newsletter
                                <span style={{
                                  fontSize: '24px',
                                  transform: newsletterExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                  transition: 'transform 0.3s ease'
                                }}>›</span>
                              </div>
                              {newsletterExpanded && (
                                <>
                                  <Nav.Link
                                    className="quick-access-mobile-link"
                                    href={newsletter.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ paddingLeft: '1.5rem' }}
                                  >
                                    {t("homepage.currentIssue")}
                                  </Nav.Link>
                                  <Nav.Link
                                    className="quick-access-mobile-link"
                                    href={newsletter.link}
                                    target="_blank"
                                    rel="noreferrer"
                                    style={{ paddingLeft: '1.5rem' }}
                                  >
                                    {t("homepage.previousIssue")}
                                  </Nav.Link>
                                </>
                              )}
                            </>
                          )}

                          {/* Health & Wellness Section */}
                          <div style={{ fontWeight: '700', padding: '0.9rem', fontSize: '17px', marginTop: '0.5rem' }}>
                            {t("homepage.healthWellness")}
                          </div>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/retirees/articleslist'
                            style={{ paddingLeft: '1.5rem' }}
                          >
                            {t("homepage.articles")}
                          </Nav.Link>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/retirees/programslist'
                            style={{ paddingLeft: '1.5rem' }}
                          >
                            {t("homepage.quick_access_programs")}
                          </Nav.Link>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/retirees/recipeslist'
                            style={{ paddingLeft: '1.5rem' }}
                          >
                            {t("homepage.recipes")}
                          </Nav.Link>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/retirees/wellnessevents'
                            style={{ paddingLeft: '1.5rem' }}
                          >
                            {t("homepage.wellnessevents")}
                          </Nav.Link>
                        </>
                      ) : (
                        <>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/articleslist'
                          >
                            {t("homepage.articles")}
                          </Nav.Link>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href='/recipeslist'
                          >
                            {t("homepage.recipes")}
                          </Nav.Link>
                          <Nav.Link
                            className="quick-access-mobile-link"
                            href="https://www.emiia.org/contact"
                          >
                            {t("homepage.contact2")}
                          </Nav.Link>
                        </>
                      )}
                    </div>
                  ) : (
                    <>
                      <ul className="quickAccess-ul list-unstyled">
                        {quickAccessLinks?.map((itemLink, index) => {
                          return (
                            <QuickAccessItem
                              isMobile={true}
                              key={index}
                              itemquickacces={itemLink}
                            />
                          );
                        })}
                      </ul>
                    </>
                  )}
                </>
              )}
              <RetireePortalButton />
              <div
              style={{
                marginTop: "1.9rem",
                borderTop: "1px solid #e5e5e5",
                display: "flex",
                justifyContent: "center",
              }}
              >
                <div className="text-bottom-quickAccess">
                  <h4
                    style={{
                      width: "max-content",
                      padding: "0 5px",
                      color: "#8F003C",
                    }}
                  >
                    MIIA
                  </h4>
                  <p
                  style={{
                    fontSize: "0.7rem",
                    color: "#b0b2b8",
                    marginTop: "auto"
                  }}
                  >is a Membership Service of the</p>
                  <label
                    style={{
                      fontSize: "0.8rem",
                      width: "max-content",
                      padding: "0 0px",
                    }}
                  ></label>
                  <img className="mma-logo" src={MMALogo} />
                </div>
              </div>
            </>
          )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}

export default QuickAccessMobileNav;
